<template>
  <v-dialog v-model="show" width="1200px" height v-if="data != null" persistent>
    <v-dialog v-model="newItemAddModal" width="600px" persistent>
      <v-card class="pa-4">
        <!--<div class="overline mb-2" style="font-size: 15px !important">
          Dodaj element do grupy
          <span v-if="this.data.groupList[selectedGroupIndex] != undefined">
            {{ this.data.groupList[selectedGroupIndex].name }}
          </span>
        </div>-->
        <v-form v-model="newItemIsValid">
          <v-col>
            <v-text-field
              dense
              v-model="newItemName"
              outlined
              label="Nazwa*"
              :rules="notEmptyRule"
              clearable
              required
            />
            <v-text-field
              dense
              v-model="newItemWarehouseId"
              outlined
              label="Wfirma ID*"
              :rules="requiredNumberOnlyRule"
            />
            <v-text-field
              dense
              v-model="newItemMpn"
              outlined
              label="Kod producenta"
            >
              <v-tooltip bottom slot="append">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on"> mdi-help-circle-outline </v-icon>
                </template>
                <span
                  >W przypadku nie wypełnienia tego pola kod producenta zostanie
                  pobrany z produktu wfirma</span
                >
              </v-tooltip>
            </v-text-field>
            <v-select
              class="shrink pa-0 ma-0"
              hide-details="true"
              v-model="newItemSelectedDistributors"
              :items="distributorsList"
              dense
              outlined
              label="Dystrybutorzy"
              multiple
              :rules="atLeastOneSelectedRule"
            >
              <template v-slot:item="{ item }">
                <img
                  :src="require(`@/assets/icons/${item.toLowerCase()}.png`)"
                  height="16px"
                  width="16px"
                  style="margin-right: 5px"
                />
                {{ item }}
              </template>
            </v-select>
          </v-col>
        </v-form>
        <v-col class="text-right">
          <v-btn
            color="primary"
            @click="addItem()"
            class="mr-1"
            :disabled="!newItemIsValid"
            >Dodaj</v-btn
          >
          <v-btn outlined @click="cancelAddItem()">Anuluj</v-btn>
        </v-col>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editItemModal" width="600px" persistent>
      <v-card class="pa-4">
        <!--<div class="overline mb-2" style="font-size: 15px !important">
          Edytuj element
          <span v-if="this.data.groupList[selectedGroupIndex] != undefined">
            {{ this.data.groupList[selectedGroupIndex].name }
          </span>
        </div>
        -->
        <v-form v-model="editItemIsValid">
          <v-col>
            <v-text-field
              dense
              v-model="editItemName"
              outlined
              label="Nazwa"
              :rules="notEmptyRule"
              clearable
            />
            <v-text-field
              dense
              v-model="editItemWarehouseId"
              outlined
              label="Wfirma ID"
              :rules="requiredNumberOnlyRule"
            />
            <v-text-field
              dense
              v-model="editItemMpn"
              outlined
              label="Kod producenta"
            >
              <v-tooltip bottom slot="append">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on"> mdi-help-circle-outline </v-icon>
                </template>
                <span
                  >W przypadku nie wypełnienia tego pola kod producenta zostanie
                  pobrany z produktu wfirma</span
                >
              </v-tooltip>
            </v-text-field>
            <v-select
              class="shrink pa-0 ma-0"
              hide-details="true"
              v-model="editItemSelectedDistributors"
              :items="distributorsList"
              dense
              outlined
              label="Dystrybutorzy"
              multiple
              :rules="atLeastOneSelectedRule"
            >
              <template v-slot:item="{ item }">
                <img
                  :src="require(`@/assets/icons/${item.toLowerCase()}.png`)"
                  height="16px"
                  width="16px"
                  style="margin-right: 5px"
                />
                {{ item }}
              </template>
            </v-select>
          </v-col>
        </v-form>
        <v-col class="text-right">
          <v-btn
            color="primary"
            @click="editItem()"
            class="mr-1"
            :disabled="!editItemIsValid"
            >Zatwierdź</v-btn
          >
          <v-btn outlined @click="cancelEditItem()">Anuluj</v-btn>
        </v-col>
      </v-card>
    </v-dialog>
    <v-card class="pa-4">
      <div class="overline mb-2" style="font-size: 16px !important">
        {{ this.data?.name || "Tworzenie nowej grupy" }}
      </div>
      <v-col>
        <v-text-field
          dense
          v-model="data.name"
          outlined
          label="Nazwa grupy"
          :rules="notEmptyRule"
          clearable
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          dense
          v-model="data.requiredCount"
          outlined
          label="Wymagana liczba sztuk"
          :rules="requiredPositiveNumberOnlyRule"
          clearable
          type="number"
        ></v-text-field>
      </v-col>

      <div>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" width="200px">Nazwa</th>
                <th class="text-left" width="100px">Kod wfirma</th>
                <th class="text-left" width="180px">Kod producenta</th>
                <th class="text-center" width="120px">Dystrybutorzy</th>
                <th class="text-center" width="30px">Akcje</th>
                <th class="text-center" v-if="showStocks" width="100px">
                  Stan
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, itemIndex) in data.componentList"
                :key="item.id"
              >
                <td>{{ item.name }}</td>
                <td>
                  <a
                    :href="`https://wfirma.pl/goods/view/${item.warehouseId}`"
                    target="_blank"
                    >{{ item.warehouseId }}</a
                  >
                </td>
                <td>{{ item.mpn }}</td>
                <td class="text-center">
                  <img
                    v-for="distributor in item.selectedDistributors"
                    :key="distributor"
                    :src="
                      require(`@/assets/icons/${distributor.toLowerCase()}.png`)
                    "
                    height="14px"
                    width="14px"
                    style="margin-right: 5px"
                  />
                </td>
                <td class="text-center">
                  <v-icon small @click="showItemEdit(itemIndex)"
                    >mdi-pencil</v-icon
                  >
                  <v-icon small @click="removeItem(itemIndex)"
                    >mdi-trash-can-outline</v-icon
                  >
                </td>
                <td class="text-center" v-if="showStocks">
                  {{ getForWarehouseId(item.warehouseId) }}
                </td>
              </tr>
              <tr v-if="showStocks" style="background-color: #ededed">
                <td class="text-right"><b>DOSTĘPNE:</b></td>
                <td class="text-center" color="#ededed">
                  <b
                    >{{ getSum() }} / {{ data.requiredCount }} =
                    {{ Math.floor(getSum() / data.requiredCount) }}
                    szt.</b
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <v-row no-gutters class="mt-5 ml-2">
        <v-col class="text-left">
          <v-btn outlined class="mr-1" @click="showItemAdd()">
            Dodaj komponent
          </v-btn>
          <v-btn outlined class="mr-1" @click="getStocks()"
            >Sprawdź stany</v-btn
          >
        </v-col>
        <v-col class="text-right">
          <v-btn @click="saveComponentGroup()" class="mr-1" color="primary"
            >Zapisz</v-btn
          >
          <v-btn
            outlined
            @click="
              () => {
                Object.assign(this.$data, this.$options.data());
                $emit('input', false);
              }
            "
            class="mr-1"
            >Zamknij</v-btn
          >
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  methods: {
    editGroup() {
      this.data.name = this.editGroupName?.trim() || "";
      this.data.requiredCount = this.editGroupRequiredCount?.toString() || "0";
      this.editGroupModal = false;
    },
    cancelEditGroup() {
      this.editGroupModal = false;
    },
    showItemAdd(groupIndex) {
      this.newItemAddModal = true;
      this.selectedGroupIndex = groupIndex;
      this.newItemSelectedDistributors = ["WFIRMA"];
      this.newItemIsValid = false;
      this.newItemName = '';
      this.newItemWarehouseId = '';
      this.newItemMpn = '';
    },
    addItem() {
      const newItem = {
        id: crypto.randomUUID(),
        name: this.newItemName.trim(),
        warehouseId: this.newItemWarehouseId.trim(),
        mpn:
          this.newItemMpn == undefined
            ? this.newItemMpn
            : this.newItemMpn.trim(),
        selectedDistributors: this.newItemSelectedDistributors,
      };
      const updatedComponentList = [...this.data.componentList, newItem];
      this.data = { ...this.data, componentList: updatedComponentList };
      this.newItemName = undefined;
      this.newItemWarehouseId = undefined;
      this.newItemMpn = undefined;
      this.newItemSelectedDistributors = ["WFIRMA"];
      this.newItemAddModal = false;
      this.showStocks = false;
    },
    cancelAddItem() {
      this.newItemAddModal = false;
    },
    removeItem(itemIndex) {
      this.data.componentList = this.data.componentList.filter(
        (item) => item.id != this.data.componentList[itemIndex].id
      );
    },
    showItemEdit(itemIndex) {
      this.selectedItemIndex = itemIndex;
      this.editItemId = this.data.componentList[itemIndex].id;
      this.editItemName = this.data.componentList[itemIndex].name;
      this.editItemWarehouseId = this.data.componentList[itemIndex].warehouseId;
      this.editItemMpn = this.data.componentList[itemIndex].mpn;
      this.editItemSelectedDistributors =
        this.data.componentList[itemIndex].selectedDistributors;
      
      // Set validation to true initially since we're pre-populating with valid data
      this.editItemIsValid = true;
      this.editItemModal = true;
    },
    editItem() {
      const editedItem = {
        id: crypto.randomUUID(),
        name: this.editItemName.trim(),
        warehouseId: this.editItemWarehouseId.trim(),
        mpn:
          this.editItemMpn == undefined
            ? this.editItemMpn
            : this.editItemMpn.trim(),
        selectedDistributors: this.editItemSelectedDistributors,
      };
      this.data.componentList = [
        ...this.data.componentList.filter((item) => item.id != this.editItemId),
        editedItem,
      ];
      this.editItemModal = false;
      this.showStocks = false;
    },
    cancelEditItem() {
      this.editItemModal = false;
    },
    saveComponentGroup() {
      // Convert requiredCount to number before saving
      const dataToSave = {
        ...this.data,
        requiredCount: parseInt(this.data.requiredCount || "0", 10)
      };
      
      this.$store
        .dispatch("saveComponentGroup", {
          id: dataToSave.id,
          body: JSON.stringify(dataToSave),
        })
        .then(() => {
          this.$store.dispatch("snackbar/setSnackbar", {
            color: "success",
            text: "Zapisano!",
          });
          this.$emit("input", false);
          this.$emit("saved");
        })
        .catch((error) => {
          error.response.data.forEach((item) => {
            this.$store.dispatch("snackbar/setSnackbar", {
              color: "error",
              text: item,
            });
          });
        });
    },
    getStocks() {
      var arr = [];
      this.data.componentList.forEach((item) => {
        arr.push(item);
      });
      this.$store
        .dispatch("getWfirmaStocks", {
          body: JSON.stringify(arr),
        })
        .then((success) => {
          this.stocksData = success.data;
          this.showStocks = true;
        })
        .catch((error) => {
          console.log(error);
          this.$store.dispatch("snackbar/setSnackbar", {
            color: "error",
            text: "Wystąpił problem z pobieraniem stanów",
          });
        });
    },
    getForWarehouseId(warehouseId) {
      if (this.stocksData != undefined) {
        var product = this.stocksData.find((p) => p.warehouseId == warehouseId);
        if (product != undefined) {
          return product.sum + " szt.";
        } else {
          return "Nie znaleziono!";
        }
      }
    },
    getSum() {
      var num = 0;
      this.data.componentList.forEach((item) => {
        var product = this.stocksData.find(
          (p) => p.warehouseId == item.warehouseId
        );
        if (product != undefined) {
          num += product.sum;
        }
      });
      return num;
    },
  },
  props: {
    value: Boolean,
    data: null,
  },
  data() {
    return {
      editGroupModal: false,
      newItemAddModal: false,
      editItemModal: false,
      newGroupIsValid: false,
      newGroupName: undefined,
      newGroupRequiredCount: 0,
      editGroupName: undefined,
      editGroupRequiredCount: 0,
      editGroupIsValid: false,
      newItemIsValid: false,
      newItemName: undefined,
      newItemWarehouseId: undefined,
      newItemMpn: undefined,
      newItemSelectedDistributors: [],
      editItemIsValid: false,
      editItemId: undefined,
      editItemName: undefined,
      editItemWarehouseId: undefined,
      editItemMpn: undefined,
      editItemSelectedDistributors: [],
      selectedGroupIndex: 0,
      selectedItemIndex: 0,
      showStocks: false,
      stocksData: undefined,
      distributorsList: [
        "AB",
        "ACC",
        "ACTION",
        "ALSO",
        "INGRAM",
        "TECHDATA",
        "WFIRMA",
      ],
      notEmptyRule: [
        (v) => {
          // Allow initially empty values or valid values
          if (v === undefined || v === null) return true;
          if (v === "" && this.show) return "Pole wymagane!";
          return (v && v.toString().length > 0) || "Pole wymagane!";
        }
      ],
      requiredNumberOnlyRule: [
        (v) => {
          if (v === undefined || v === null) return true; // Don't validate empty fields initially
          if (v && v.length > 0 && !isNaN(parseFloat(v))) return true;
          return "Pole wymagane, tylko liczby!";
        },
      ],
      atLeastOneSelectedRule: [
        (v) => {
          if (!v) return true; // Don't validate if v is undefined or null
          return v.length > 0 || "Musisz wybrać co najmniej jedną opcję!";
        },
      ],
      requiredPositiveNumberOnlyRule: [
        (v) => {
          // Special handling for requiredCount field - allow empty/zero values initially
          if (v === undefined || v === null || v === '') return true;
          // Convert string to number for comparison
          const numVal = parseFloat(v);
          // Valid if it's a number and >= 0
          if (!isNaN(numVal) && numVal >= 0) return true;
          // Otherwise show error message
          return "Pole wymagane, tylko pozytywne liczby!";
        },
      ],
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          // Ensure componentList is initialized
          if (!newVal.componentList) {
            this.data = {
              ...newVal,
              componentList: []
            };
          }
          
          // Convert requiredCount to string if it's a number
          if (typeof newVal.requiredCount === 'number') {
            this.data = {
              ...this.data,
              requiredCount: String(newVal.requiredCount)
            };
          }
        }
      }
    },
    // Set modal validation state when opening/closing
    show(isVisible) {
      if (isVisible && this.data) {
        // Pre-validate form when opening modal with existing data
        this.$nextTick(() => {
          // Set up validation states to avoid invalid indicators
          this.newItemIsValid = true;
          this.editItemIsValid = true;
          this.editGroupIsValid = true;
          this.newGroupIsValid = true;
        });
      }
    }
  }
};
</script>
<style scoped>
a {
  color: #ffffff;
  text-decoration: none;
}
.material-icons {
  vertical-align: middle;
}
</style>
